import React from "react";
import { m } from "kremling";

type LinkCellProps = {
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  label: string;
  isDisabled?: boolean;
};

export function LinkCell({ href, onClick, label, isDisabled }: LinkCellProps) {
  return (
    <>
      {(href || onClick) && !isDisabled ? (
        <a href={href} onClick={onClick}>
          {label}
        </a>
      ) : (
        <span className={m("cp-data-table-cell-disabled", isDisabled)}>
          {label}
        </span>
      )}
    </>
  );
}
